import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey = 'previewDisabledText';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  previewDisabledText: {
    id: 'boxFileRequest.submitter.previewDisabledText',
    description: 'Text to display when previewing a disabled file request',
    defaultMessage:
      'This file request link is currently disabled. Enable the link to allow others to view this webpage and upload files.',
  },
});

export default messages;
